import { Box, Text } from '@mantine/core';
import { MoonTokenAmount } from 'components/TokenAmount';
import { MoonTokenFiatPrice } from 'components/TokenFiatPrice/MoonTokenFiatPrice';
import { useThemeColors } from 'hooks/useThemeColors';

interface Props {
  label: string;
  amount: bigint;
}

export function InfoLine({ label, amount }: Props) {
  const { themeColors } = useThemeColors();

  return (
    <Box>
      <MoonTokenAmount
        amount={amount}
        fz={24}
        isHidable={true}
        lh={1}
        maxDecimals={4}
      />
      <MoonTokenFiatPrice
        amount={amount}
        c={themeColors.secondaryTexts}
        fz={'sm'}
        isHidable={true}
      />
      <Text size={'sm'} lh={1.2}>
        {label}
      </Text>
    </Box>
  );
}
